
import React from "react";
import { ContactSettings } from "../types";
import { Phone, Mail, MapPin, Facebook, Twitter, Linkedin, Instagram } from "lucide-react";

interface FooterProps {
  settings: ContactSettings;
}

const Footer: React.FC<FooterProps> = ({ settings }) => {
  return (
    <footer className="bg-slate-900 text-slate-300 pt-16 pb-8 px-6 transition-colors">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
        {/* Brand Section */}
        <div className="space-y-6">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center text-white font-black italic">S</div>
            <span className="text-xl font-black text-white uppercase tracking-tighter">Sai SSK <span className="text-blue-500">Infrastructures</span></span>
          </div>
          <p className="text-sm leading-relaxed text-slate-400">
            Leading the way in heavy civil engineering and road infrastructure. Building the foundations for tomorrow's connectivity.
          </p>
          <div className="flex gap-4">
            <a href="#" className="w-8 h-8 rounded-full bg-slate-800 flex items-center justify-center hover:bg-blue-600 hover:text-white transition-all"><Facebook size={14} /></a>
            <a href="#" className="w-8 h-8 rounded-full bg-slate-800 flex items-center justify-center hover:bg-blue-600 hover:text-white transition-all"><Twitter size={14} /></a>
            <a href="#" className="w-8 h-8 rounded-full bg-slate-800 flex items-center justify-center hover:bg-blue-600 hover:text-white transition-all"><Linkedin size={14} /></a>
            <a href="#" className="w-8 h-8 rounded-full bg-slate-800 flex items-center justify-center hover:bg-blue-600 hover:text-white transition-all"><Instagram size={14} /></a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-white font-black uppercase text-[10px] tracking-[0.2em] mb-6">Navigation</h4>
          <ul className="space-y-3 text-sm">
            <li><a href="#" className="hover:text-blue-400 transition-colors">Home Portfolio</a></li>
            <li><a href="#" className="hover:text-blue-400 transition-colors">About Our Legacy</a></li>
            <li><a href="#" className="hover:text-blue-400 transition-colors">Active Projects</a></li>
            <li><a href="#" className="hover:text-blue-400 transition-colors">Career Openings</a></li>
            <li><a href="#" className="hover:text-blue-400 transition-colors">Contact Support</a></li>
          </ul>
        </div>

        {/* Services */}
        <div>
          <h4 className="text-white font-black uppercase text-[10px] tracking-[0.2em] mb-6">Expertise</h4>
          <ul className="space-y-3 text-sm">
            <li><a href="#" className="hover:text-blue-400 transition-colors">Highway Construction</a></li>
            <li><a href="#" className="hover:text-blue-400 transition-colors">Bridge Engineering</a></li>
            <li><a href="#" className="hover:text-blue-400 transition-colors">Urban Infrastructure</a></li>
            <li><a href="#" className="hover:text-blue-400 transition-colors">Earthworks & Grading</a></li>
            <li><a href="#" className="hover:text-blue-400 transition-colors">Pavement Technology</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h4 className="text-white font-black uppercase text-[10px] tracking-[0.2em] mb-6">Contact Hub</h4>
          <ul className="space-y-4 text-sm">
            <li className="flex items-start gap-3">
              <MapPin size={16} className="text-blue-500 shrink-0 mt-0.5" />
              <span className="text-slate-400">{settings.address}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone size={16} className="text-blue-500 shrink-0" />
              <span className="text-slate-400">{settings.phone}</span>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={16} className="text-blue-500 shrink-0" />
              <span className="text-slate-400">{settings.email}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-[10px] font-black uppercase tracking-[0.1em] text-slate-500">
          © {new Date().getFullYear()} Sai SSK Infrastructures. All rights reserved.
        </p>
        <div className="flex gap-6 text-[10px] font-black uppercase tracking-[0.1em] text-slate-500">
          <a href="#" className="hover:text-slate-300 transition-colors">Privacy Policy</a>
          <a href="#" className="hover:text-slate-300 transition-colors">Terms of Service</a>
          <a href="#" className="hover:text-slate-300 transition-colors">Cookie Settings</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
